<template>
    <div>
        <section>
            <div class="container">
                <img :src="product.logo" :title="product.name" class="img-logo" /><sup class="text-black text-h5 text-weight-bold on-right" style="vertical-align: top">{{ product.year }}</sup>
                <div class="row q-col-gutter-lg justify-between q-pt-sm">
                    <div class="col-xs-12 col-md-7">
                        <p>
                            LengthWise is the software that will assist you with the planning and optimization of cuts from linear stock materials. Whether you are working with piping, tubing, bar stock, or linear lumber, LengthWise can help you optimize your cuts and minimize materials waste and handling. Try it now free for 30 days.
                        </p>
                        <p>The free Trial Version of LengthWise allows you to try its great new features, at no-obligation, for up to 30 days. Download your copy now by clicking on the link below.</p>
                        <div class="row q-col-gutter-sm">
                            <div class="col-xs-12 col-sm-auto">
                                <q-btn class="full-width bg-white text-primary"
                                       style="border: 1px solid currentColor; height: 95%;"
                                       label="Free Trial"
                                       icon="mdi-download"
                                       @click="ScrollTo($refs.trialRef, '#trial')" />
                            </div>
                            <div class="col-xs-12 col-sm-auto">
                                <q-btn label="Pricing" color="positive" icon="mdi-cart"
                                       :to="{ name:'/store', params: { productLine: 'lengthwise'}}"
                                       class="full-width" />
                            </div>
                        </div>
                    </div>
                    <div class="gt-sm col-md-5 text-right">
                        <img :src="require('@/assets/img/splash/lengthwise-splash.jpg')" class="img-intro" />
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="container">
                <div class="text-title">Pricing and Activation</div>
                <p>
                    When you first install LengthWise it will automatically be in Trial Version mode. You can choose to purchase a license and activate your copy anytime during the trial period, or after the expiry. Simply visit the <router-link :to="{ name:'/store', params: { productLine: 'lengthwise'}}">Store</router-link>, add LengthWise to your cart, and have your "Install ID" and payment information available.
                </p>
                <p>
                    To locate your "Install ID", run LengthWise then choose the "Help | Activate..." menu. The Activation window will open, displaying your Install ID.
                </p>
            </div>
        </section>
        <div ref="trialRef">
            <free-trial :productLine="product" />
        </div>
        <system-requirements :sysReq="product.sysReq" />
    </div>
</template>
<script>
    import systemRequirements from '@/components/SystemRequirements'
    import freeTrial from '@/components/FreeTrial'
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'lengthwise',
        components: {
            systemRequirements,
            freeTrial,
        },
        data() {
            return {
                product: productLines.LengthWise,
            }
        },
        methods: {
            ScrollTo(element, hash) {
                const currentHash = this.$route.hash;
                const targetHash = hash;

                if (currentHash !== targetHash) {
                    this.scrollToElement(element);
                    this.$router.push({ path: this.$route.path + "/", hash: targetHash });
                } else {
                    this.scrollToElement(element);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    @media (max-width: $breakpoint-xs-max) {
        .img-logo {
            max-height: 55px;
        }
    }

    .img-intro {
        width: 450px;
        width: 100%;
    }
</style>
